import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from '../../../auth/AuthContext';

import ErrorBoundary from '../ErrorBoundry/ErrorBoundary';

import PostLoginLayout from '../../Layouts/PostLoginLayout';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          <ErrorBoundary>
            <PostLoginLayout>
              <Component />
            </PostLoginLayout>
          </ErrorBoundary>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.shape().isRequired,
};

export default PrivateRoute;
